import ToastContainer from "react-bootstrap/ToastContainer"
import { ToastView } from "./Alert"


export interface AlertModel {
    title: string
    description?: string
    time?: string
    state: 'primary' | 'danger' | 'warning' | 'success' | 'info'
}type Props = {
    alerts: AlertModel[]
}

const AlertView: React.FC<Props> = ({ alerts }) => {
    return (

        <ToastContainer
            className="p-3 position-fixed"
            position='top-end'
            style={{ zIndex: 999 }}
        >
            {alerts?.map((alert, index) => {
                return (
                    <ToastView key={`toast-${index}`} alert={alert} />
                );
            })}
        </ToastContainer>
    );
}


export { AlertView }